/* eslint-disable */
import { createReducer, createActions } from "reduxsauce"
import Immutable from "seamless-immutable"

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({

    kargoeRequest :null,
    kargoeSuccess: ["response"],
    kargoeFailure: ["response"],

})

export const HappeningsTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
   
    fetching: null,
    data :[],
    error: null
})

/* ------------- Reducers ------------- */


export const kargoeRequest = (state, action) => {
   
    return state.merge({
        fetching: true,
        error: null
    })
}
export const kargoeSuccess = (state, action) => {
    const { response : {data: {data} }} = action
   
    console.tron.display({
        name: 'Happening Success',
        preview: 'You should totally expand this',
        value: {
            action: action,
            response: data,
            apiResponse: data
        }
    }) 
    return state.merge({
        fetching: false,
        error: null,
        data
    })
}
export const kargoeFailure = (state, action) => {
   
    return state.merge({
        fetching: false,
        error: null
    })
}

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {


    [Types.KARGOE_REQUEST]: kargoeRequest,
    [Types.KARGOE_SUCCESS]: kargoeSuccess,
    [Types.KARGOE_FAILURE]: kargoeFailure,

 
})
